/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer.js';
import Switcher from '/client/src/components/switcher';
import Loader from '/client/src/components/Loader';
import { PUT } from '/client/src/api/';
import CssPinner from '/client/src/components/csspinner';

type PropsType = {
  handleTogglePreviewModal: (boolean) => void
};

const IntegrationsCardsEmbed = ({ handleTogglePreviewModal }: PropsType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);
  const [IsCheckSwitcher, isToggleCheckSwitcher] = React.useState(false);

  const handleLoaded = React.useCallback(
    async (error: Error, response: any) => {
      if (!error) {
        try {
          const status = _.get(response.data.result, 'is_enable_card_iframe_comp_mode', false);

          isToggleCheckSwitcher(status);
        } catch (e) {
          // console.error('cant get events list');
          context.handleShowSystemDialog(true, {
            systemDialogType: 'error',
            systemDialogTitle: 'Error!',
            systemDialogContent: 'Error'
          });
        }
      }
    },
    []
  );

  const requestToChangeSwitcherStatus = async (status: boolean) => {
    try {
      CssPinner(document.body, true);

      await PUT('/api/v1/1/merchants/event_card_settings', {
        is_enable_card_iframe_comp_mode: status
      });

      isToggleCheckSwitcher(status);

      CssPinner(document.body, false);
    } catch (e) {
      context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: 'Can\'t enable iframe mode'
      });

      isToggleCheckSwitcher(false);

      CssPinner(document.body, false);
    }
  };

  // console.log('\n\n embed.jsx : 26 /--------------------------------');
  // console.log(IsCheckSwitcher);
  // console.log('embed.jsx : 26 --------------------------------/\n\n');

  return (
    <div className="preview-codes">
      <div className="panel panel-preview">
        <div className="panel-heading">
          <div className="panel-title">
            <span className="text">
              EVENT CARD LIST
            </span>
          </div>

          <div className="pull-right">
            <span
              className="preview-link"
              onClick={(): any => handleTogglePreviewModal(true)}
            >
              <i className="icon icon-eye" />
            </span>
          </div>

        </div>

        <div className="panel-body">
          <div className="input-group clearfix">
            <span className="input-group-addon">
              <i className="icon icon-code" />
            </span>

            <textarea
              rows="5"
              className="form-control"
              readOnly
              value={`<div class="sparxo-nest-cards sparxo-id-${context.profileCurrent.id}"></div><script>(function (d, s, b) {if (d.getElementById(b)) {return;} var l, f = d.getElementsByTagName(s)[0];l = d.createElement(s);l.id = b;l.src = "${process.env.EVENT_HOST}assets/shared/client.js";f.parentNode.insertBefore(l, f);}(document, 'script', 'sparxo-js'));</script>`}
            />

            <div className="input-group-addon preview-item calendar" />
          </div>
        </div>

        <div className="panel-heading">
          <div className="panel-title">
            <span className="text">
              EVENT CARD SETTINGS
            </span>
          </div>
        </div>

        <div className="panel-body">
          <div
            className="1input-group clearfix"
            style={{
              marginLeft: '1rem',
              width: '100%',
              maxWidth: '285px',
              minHeight: '50px',
              position: 'relative'
            }}
          >
            <Loader
              url={`/api/v1/1/merchants/${context.profileCurrent.id}/events_card`}
              onLoaded={handleLoaded}
            >
              <Switcher
                className='form-switcher-sm pull-left mb1rem'
                id='cardListSettings'
                name='cardListSettings'
                index='cardListSettings'
                checked={IsCheckSwitcher}
                onCallback={(e: any, status: boolean) => {
                  requestToChangeSwitcherStatus(status);
                }}
                label='Enable iframe compatibility mode'
              />
            </Loader>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntegrationsCardsEmbed;
